import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { Button } from "../../elements/Button";

const sizeFormat = new Intl.NumberFormat("en-GB", {
  useGrouping: true,
  maximumFractionDigits: 0,
});

/** An export's size in kilobytes. */
export function AudienceExportSize({ value }: { value?: unknown }) {
  return value === null || value === undefined || value === "" ? null : (
    <>{`${sizeFormat.format(Number(value) / 1024)}kb`}</>
  );
}

/** Downloads the export the row stands for. */
export function AudienceExportDownload({
  row,
}: {
  row?: Record<string, unknown>;
}) {
  return (
    <Button
      title="Download"
      icon={faDownload}
      variant="link"
      className="p-0 text-decoration-none"
      onClick={async () => {
        const { downloadAnnotation } = await import("../../utils/utility");
        downloadAnnotation(row?.id);
      }}
    />
  );
}

const exportTypes: Record<string, string> = {
  csv: "CSV",
  xml: "XML",
  "text/csv": "CSV",
  "text/xml": "XML",
  "application/xml": "XML",
  // How Ticketing stores an XML export.
  "application/octet-stream": "XML",
};

/** An export's file type, from the mime type it is stored with or the name it came back with. */
export const audienceExportType = (mimeType: unknown) =>
  exportTypes[String(mimeType ?? "").toLowerCase()] ?? "";
